'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { AccessRulesListPage, IDP_AUTH_POLICY_PATHS } from '@/features/authentication-policy';
export const Route = createFileRoute('/_staff/idp/_layout/access-rules/')({
  component: () => <AccessRulesListPage paths={IDP_AUTH_POLICY_PATHS} />
});